import "./Button.scss";

interface ButtonPrimaryParams {
    onClick: () => void;
    text: string;
}

export const ButtonPrimary = ({ onClick, text }: ButtonPrimaryParams) => {
    return <button className='ButtonPrimary' onClick={onClick}>{text}</button>;
}